import { AxiosResponse } from 'axios';
import { Rest, IRestResponse } from '../../rest/Rest';

export default class DoryRequest {
  public serviceRest: Rest;

  private url: string;
  public get Url(): string {
    return this.url;
  }
  public set Url(url: string) {
    this.url = url;
  }
  private id: number;
  private running: boolean;

  constructor(url: string, serviceRest: Rest) {
    this.serviceRest = serviceRest;
    this.url = url;
    this.running = false;
  }

  private *restGenerator(
    success: (r: AxiosResponse) => void,
    fail: (e: string) => void
  ): IterableIterator<Promise<void>> {
    while (this.running) {
      yield this.serviceRest.get(this.url).catch(fail).then(success);
    }
  }

  public poll(
    ms = 3000,
    stopOnError = false,
    snapshot = true,
    immediateUnsubscribe = true
  ): {
    get: (
      success: (r: IRestResponse) => void,
      fail: (e: string) => void
    ) => void;
  } {
    this.running = true;
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    return {
      get(success: (r: IRestResponse) => void, fail: (e: string) => void) {
        // Enhance success-callback for immediateUnsubscribe
        const cbSuccess = (r: IRestResponse) => {
          if (!immediateUnsubscribe || self.running) {
            success(r);
          }
        };
        // Enhance fail-callback to stop on error
        const cbFail = (e: string) => {
          if (stopOnError) {
            self.cancel();
          }
          fail(e);
        };

        // Create Generator
        const generator: IterableIterator<Promise<void>> = self.restGenerator(
          cbSuccess,
          cbFail
        );

        // Get Snapshot
        if (snapshot) {
          generator.next();
        }
        // Start Loop
        self.id = window.setInterval(() => {
          generator.next();
        }, ms);
      },
    };
  }

  public cancel(): void {
    if (this.id) {
      window.clearInterval(this.id);
      this.id = undefined;
      this.running = false;
    }
  }
}
